import { render, staticRenderFns } from "./acmula.vue?vue&type=template&id=00147ace&"
import script from "./acmula.vue?vue&type=script&lang=js&"
export * from "./acmula.vue?vue&type=script&lang=js&"
import style0 from "./acmula.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports